import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { secretService } from '../../services/secretService';

export const fetchSecrets = createAsyncThunk(
  'secrets/fetchSecrets',
  async (_, { rejectWithValue }) => {
    try {
      const response = await secretService.getAllSecrets();
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to fetch secrets');
    }
  }
);

export const addSecret = createAsyncThunk(
  'secrets/addSecret',
  async ({ payload, secretKey }, { rejectWithValue }) => {
    try {
      const response = await secretService.addSecret(payload, secretKey);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to add secret');
    }
  }
);

export const deleteSecret = createAsyncThunk(
  'secrets/deleteSecret',
  async ({ id, secretKey }, { rejectWithValue }) => {
    try {
      await secretService.deleteSecret(id, secretKey);
      return id;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to delete secret');
    }
  }
);

const secretsSlice = createSlice({
  name: 'secrets',
  initialState: {
    items: [],
    categories: [],
    loading: false,
    error: null,
    lastFetched: null
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      // Fetch Secrets
      .addCase(fetchSecrets.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSecrets.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
        state.lastFetched = Date.now();
      })
      .addCase(fetchSecrets.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Add Secret
      .addCase(addSecret.fulfilled, (state, action) => {
        state.items.push(action.payload);
      })
      // Delete Secret
      .addCase(deleteSecret.fulfilled, (state, action) => {
        state.items = state.items.filter(secret => secret._id !== action.payload);
      });
  }
});

export const { clearError } = secretsSlice.actions;
export default secretsSlice.reducer;
